import {GameState, NestedReadonly} from '@colonist/game-states'
import React, {ReactNode, createContext, useContext, useMemo, useState} from 'react'

// eslint-disable-next-line @typescript-eslint/no-empty-function
const globalGameStateSetter = {setGameState: (gameState: GameState) => {}}

export function setGlobalGameState(gameState: NestedReadonly<GameState>) {
    const gameStateNormal = gameState as GameState // all React states are mutable, no need for NestedReadonly
    globalGameStateSetter.setGameState({...gameStateNormal})
}

interface UIGameStateContextProps {
    gameState: GameState
    setGameState: (gameState: GameState) => void
}
const UIGameStateContext = createContext<UIGameStateContextProps>({} as UIGameStateContextProps)

export function UIGameStateProvider({
    children,
    initialGameState,
}: {
    children: ReactNode
    initialGameState: GameState
}) {
    const [gameState, setGameState] = useState(initialGameState)
    globalGameStateSetter.setGameState = setGameState

    const contextValue = useMemo(() => ({
        gameState: gameState, setGameState: setGameState,
    }), [gameState, setGameState])
    return (
        <UIGameStateContext.Provider value={contextValue}>
            {children}
        </UIGameStateContext.Provider>
    )
}
export function useUIGameStateContext() {
    const gameState = useContext(UIGameStateContext)
    if(gameState == null) throw new Error('useGameState must be used within a UIGameStateProvider')

    return gameState
}
